import 'moment/locale/ja';
import { GetMessage } from '../variables/message';

// const PNF = require('google-libphonenumber').PhoneNumberFormat;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
// const moment = require("moment");

export default class Validate {
    static tel(str,label) {
        let message = "";
        let valid = true;
        let number = null;
        if(str.length > 0){
            if (!str.match(/^[0-9０-９][0-9０-９-]+[0-9０-９]$/g)){
                message = label + 'の形式が不正です';
                valid = false;               
            }else{
                number = phoneUtil.parse(str, 'JP');
                console.log(phoneUtil.isValidNumber(number));
                if (!phoneUtil.isValidNumber(number)) {
                    message = label + 'の形式が不正です';
                    valid = false;
                }
    
            }

        }
        // console.log(phoneUtil.isValidNumber(number));
        // console.log(valid);
   
        return {message,valid};
    }
    
    static length(str,label,type){
        const lengthData = valid_Length[type];
        const min = parseInt(lengthData[0]);
        const max = parseInt(lengthData[1]);
        return (str.length >= min && str.length <= max)?
        {
            message:"",
            valid: true,
            newText: str
        }:{
            message: lengthData[2],
            valid : false,
            newText: str
        }
    }

    static bankNumber(str,label,type){
        const rx = new RegExp("^([0-9])+$");

        const valid = rx.test(str)
        return (str.length<1||valid)?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: GetMessage(2022),
            valid,
            newText: str
        }
    }

    static alphanumeric(str,label,type){
        const rx = new RegExp("^([0-9a-zA-Z])+$");

        const valid = rx.test(str)
        return (str.length<1||valid)?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: GetMessage(2033),
            valid,
            newText: str
        }
    }

    static alphanumericWithUnderscore(str,label,type){
        const rx = new RegExp("^([0-9a-zA-Z_])+$");

        const valid = rx.test(str)
        return (str.length<1||valid)?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: GetMessage(2040),
            valid,
            newText: str
        }
    }

    static alphanumericWithEmail(str,label,type){
        var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(,(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+)*$/
        const rx = new RegExp(EMAIL_REGEX);

        const valid = rx.test(str)
        // const rx = new RegExp("^([0-9a-zA-Z@\\-=_\\.])+$");

        // const valid = rx.test(str)&&str.includes("@")&&str.includes(".")
        return (str.length<1||valid) ?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: GetMessage(2004),
            valid,
            newText: str
        }
    }

    static lengthWithHyphenRemove(str,label,type){
        const removedStr = str.replace(/[-]/g, "");
        const lengthData = valid_Length[type];
        const min = parseInt(lengthData[0]);
        const max = parseInt(lengthData[1]);
        return (removedStr.length >= min && removedStr.length <= max)?
        {
            message:"",
            valid: true,
            newText: str
        }:{
            message: lengthData[2],
            valid : false,
            newText: str
        }
    }

    static numberOnly(str,label,type){
        const rx = new RegExp("^([0-9])+$");
        const lengthData = valid_Length[type];
        const valid = rx.test(str)
        return (str.length<1||valid)?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: lengthData[2],
            valid,
            newText: str
        }

    }

    static alphanumericWithJapanese(str,label,type){
        const pHiragana = "[\\u3041-\\u3096\\u309D-\\u309F]|\\uD82C\\uDC01|\\uD83C\\uDE00";
        const pKatakana = "[\\u30A1-\\u30FA\\u30FD-\\u30FF\\u31F0-\\u31FF\\u32D0-\\u32FE\\u3300-\\u3357\\uFF66-\\uFF6F\\uFF71-\\uFF9D]|\\uD82C\\uDC00";
        const pHan = "[\\u2E80-\\u2E99\\u2E9B-\\u2EF3\\u2F00-\\u2FD5\\u3005\\u3007\\u3021-\\u3029\\u3038-\\u303B\\u3400-\\u4DB5\\u4E00-\\u9FD5\\uF900-\\uFA6D\\uFA70-\\uFAD9]|[\\uD840-\\uD868\\uD86A-\\uD86C\\uD86F-\\uD872][\\uDC00-\\uDFFF]|\\uD869[\\uDC00-\\uDED6\\uDF00-\\uDFFF]|\\uD86D[\\uDC00-\\uDF34\\uDF40-\\uDFFF]|\\uD86E[\\uDC00-\\uDC1D\\uDC20-\\uDFFF]|\\uD873[\\uDC00-\\uDEA1]|\\uD87E[\\uDC00-\\uDE1D]";
        const rx = new RegExp("^([\\w-]|[\\s]|" + pHiragana + "|" + pKatakana + "|" + pHan + ")+$");

        const valid = rx.test(str)
        return (str.length<1||valid)?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: GetMessage(2002),
            valid,
            newText: str
        }
    }

    static size(str,label,type){
        const sizeData = valid_MinMax[type];
        const min = parseInt(sizeData[0]);
        const max = parseInt(sizeData[1]);
        const num = isNaN(parseInt(str))?0:parseInt(str)
        return (num >= min && num <= max)?
        {
            message:"",
            valid: true,
            newText: num
        }:{
            message: sizeData[2],
            valid : false,
            newText: num
        }
    }

    static dateMinMax(str,label,type){
        const dateData = valid_Date[type];

        //時分秒は使わないためクリア
        const now = new Date();
        now.setHours(0)
        now.setMinutes(0)
        now.setSeconds(0)
        now.setMilliseconds(0)

        const nowTime = now.getTime();
        // const min = dateData[0]=="現在日時" ? nowTime : nowTime - (parseInt(dateData[0]))
        const min = dateData[0]=="現在日時" ? nowTime : 0;
        const max = nowTime + parseInt(dateData[1]);
        const num = isNaN(Date.parse(str))?0:Date.parse(str)
        console.log('min', min, 'max', max, 'num', num)
        return (num >= min && num <= max)?
        {
            message:"",
            valid: true,
            newText: str
        }:{
            message: dateData[2],
            valid : false,
            newText: str
        }
    }

    static requiredCheck(requiredData, columnName, label){
        if (requiredData && requiredData[columnName]){
            return [required_message]
        } else {
            return undefined
        }
    }

    static mobileCheck(str){
        var strHead  = str.slice( 0, 3 );
        return ['060','070','080','090'].includes(strHead) === true ?
        {
            message: "",
            valid : true,
            newText: str
        }:
        {
            message: GetMessage(2026),
            valid : false,
            newText: str
        }
    }

    static fullWidthKana(str,label,type){
        const rx = new RegExp("^([ァ-ン　 ]|ー)+$");
        const lengthData = valid_Length[type];
        const valid = rx.test(str)
        console.log(valid)
        return (str.length<1||valid)?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: lengthData[2],
            valid,
            newText: str
        }
    }

    static halfWidthKana(str,label,type){

        // ※　口座名義記入時の注意事項　※
        // https://www.city.tsuchiura.lg.jp/data/doc/1395993381_doc_38_2.pdf
        const accountHolderNameRule= 
            "ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ"
            + "ｶﾞｷﾞｸﾞｹﾞｺﾞｻﾞｼﾞｽﾞｾﾞｿﾞﾀﾞﾁﾞﾂﾞﾃﾞﾄﾞﾊﾞﾋﾞﾌﾞﾍﾞﾎﾞｳﾞ"
            + "ﾊﾟﾋﾟﾌﾟﾍﾟﾎ"
            + "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
            + "0123456789"
            + "().\\-/"
            + " "
            + "ｦ｢｣,"

        const rx = new RegExp(`^[${accountHolderNameRule}]+$`);
        const lengthData = valid_Length[type];
        const valid = rx.test(str)
        
        return (str.length<1||valid)?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: lengthData[2],
            valid,
            newText: str
        }
    }

    static autoHalfWidthKana(str,label,type){
        var kanaMap = {
            'ガ':'ｶﾞ',
            'ギ':'ｷﾞ',
            'グ':'ｸﾞ',
            'ゲ':'ｹﾞ',
            'ゴ':'ｺﾞ',
            'ザ':'ｻﾞ',
            'ジ':'ｼﾞ',
            'ズ':'ｽﾞ',
            'ゼ':'ｾﾞ',
            'ゾ':'ｿﾞ',
            'ダ':'ﾀﾞ',
            'ヂ':'ﾁﾞ',
            'ヅ':'ﾂﾞ',
            'デ':'ﾃﾞ',
            'ド':'ﾄﾞ',
            'バ':'ﾊﾞ',
            'ビ':'ﾋﾞ',
            'ブ':'ﾌﾞ',
            'ベ':'ﾍﾞ',
            'ボ':'ﾎﾞ',
            'パ':'ﾊﾟ',
            'ピ':'ﾋﾟ',
            'プ':'ﾌﾟ',
            'ペ':'ﾍﾟ',
            'ポ':'ﾎﾟ',
            'ヴ':'ｳﾞ',
            'ヷ':'ﾜﾞ',
            'ヺ':'ｦﾞ',
            'ア':'ｱ',
            'イ':'ｲ',
            'ウ':'ｳ',
            'エ':'ｴ',
            'オ':'ｵ',
            'カ':'ｶ',
            'キ':'ｷ',
            'ク':'ｸ',
            'ケ':'ｹ',
            'コ':'ｺ',
            'サ':'ｻ',
            'シ':'ｼ',
            'ス':'ｽ',
            'セ':'ｾ',
            'ソ':'ｿ',
            'タ':'ﾀ',
            'チ':'ﾁ',
            'ツ':'ﾂ',
            'テ':'ﾃ',
            'ト':'ﾄ',
            'ナ':'ﾅ',
            'ニ':'ﾆ',
            'ヌ':'ﾇ',
            'ネ':'ﾈ',
            'ノ':'ﾉ',
            'ハ':'ﾊ',
            'ヒ':'ﾋ',
            'フ':'ﾌ',
            'ヘ':'ﾍ',
            'ホ':'ﾎ',
            'マ':'ﾏ',
            'ミ':'ﾐ',
            'ム':'ﾑ',
            'メ':'ﾒ',
            'モ':'ﾓ',
            'ヤ':'ﾔ',
            'ユ':'ﾕ',
            'ヨ':'ﾖ',
            'ラ':'ﾗ',
            'リ':'ﾘ',
            'ル':'ﾙ',
            'レ':'ﾚ',
            'ロ':'ﾛ',
            'ワ':'ﾜ',
            'ヲ':'ｦ',
            'ン':'ﾝ',
            'ァ':'ｧ',
            'ィ':'ｨ',
            'ゥ':'ｩ',
            'ェ':'ｪ',
            'ォ':'ｫ',
            'ッ':'ｯ',
            'ャ':'ｬ',
            'ュ':'ｭ',
            'ョ':'ｮ',
            '。':'｡',
            '、':'､',
            'ー':'-',
            'ｰ':'-',
            '「':'｢',
            '」':'｣',
            '・':'･',
            '゜':'ﾟ',
            '゛':'ﾞ'
        };
        var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
        const newText = str.replace(reg, (match) => kanaMap[match])
        return {
            message:"",
            valid:true,
            newText
        }
    }
    static autoFullWidthKana(str,label,type){
        var kanaMap = {
            'ｶﾞ':'ガ',
            'ｷﾞ':'ギ',
            'ｸﾞ':'グ',
            'ｹﾞ':'ゲ',
            'ｺﾞ':'ゴ',
            'ｻﾞ':'ザ',
            'ｼﾞ':'ジ',
            'ｽﾞ':'ズ',
            'ｾﾞ':'ゼ',
            'ｿﾞ':'ゾ',
            'ﾀﾞ':'ダ',
            'ﾁﾞ':'ヂ',
            'ﾂﾞ':'ヅ',
            'ﾃﾞ':'デ',
            'ﾄﾞ':'ド',
            'ﾊﾞ':'バ',
            'ﾋﾞ':'ビ',
            'ﾌﾞ':'ブ',
            'ﾍﾞ':'ベ',
            'ﾎﾞ':'ボ',
            'ﾊﾟ':'パ',
            'ﾋﾟ':'ピ',
            'ﾌﾟ':'プ',
            'ﾍﾟ':'ペ',
            'ﾎﾟ':'ポ',
            'ｳﾞ':'ヴ',
            'ﾜﾞ':'ヷ',
            'ｦﾞ':'ヺ',
            'ｱ':'ア',
            'ｲ':'イ',
            'ｳ':'ウ',
            'ｴ':'エ',
            'ｵ':'オ',
            'ｶ':'カ',
            'ｷ':'キ',
            'ｸ':'ク',
            'ｹ':'ケ',
            'ｺ':'コ',
            'ｻ':'サ',
            'ｼ':'シ',
            'ｽ':'ス',
            'ｾ':'セ',
            'ｿ':'ソ',
            'ﾀ':'タ',
            'ﾁ':'チ',
            'ﾂ':'ツ',
            'ﾃ':'テ',
            'ﾄ':'ト',
            'ﾅ':'ナ',
            'ﾆ':'ニ',
            'ﾇ':'ヌ',
            'ﾈ':'ネ',
            'ﾉ':'ノ',
            'ﾊ':'ハ',
            'ﾋ':'ヒ',
            'ﾌ':'フ',
            'ﾍ':'ヘ',
            'ﾎ':'ホ',
            'ﾏ':'マ',
            'ﾐ':'ミ',
            'ﾑ':'ム',
            'ﾒ':'メ',
            'ﾓ':'モ',
            'ﾔ':'ヤ',
            'ﾕ':'ユ',
            'ﾖ':'ヨ',
            'ﾗ':'ラ',
            'ﾘ':'リ',
            'ﾙ':'ル',
            'ﾚ':'レ',
            'ﾛ':'ロ',
            'ﾜ':'ワ',
            'ｦ':'ヲ',
            'ﾝ':'ン',
            'ｧ':'ァ',
            'ｨ':'ィ',
            'ｩ':'ゥ',
            'ｪ':'ェ',
            'ｫ':'ォ',
            'ｯ':'ッ',
            'ｬ':'ャ',
            'ｭ':'ュ',
            'ｮ':'ョ',
            '｡':'。',
            '､':'、',
            '-':'ー',
            '-':'ｰ',
            '｢':'「',
            '｣':'」',
            '･':'・',
            'ﾟ':'゜',
            'ﾞ':'゛'
            };
        var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
        const newText = str.replace(reg, (match) => kanaMap[match])
        return {
            message:"",
            valid:true,
            newText
        }
    }

    static limit_max_distance(str,label,type){
        
        const search_distance = Number(str)
        let newText = search_distance
        if (search_distance >= 3000){
            newText = 3000
        } else if (0 > search_distance){
            newText = 0
        } else {
            newText = search_distance
        }

        return {
            message:"",
            valid:true,
            newText
        }
    }

    static postalCode(str,label,type){
        const rx = new RegExp("^[0-9]{3}-[0-9]{4}$");
        const valid = rx.test(str)
        return (str.length<1||valid)?
        {
            message:"",
            valid,
            newText: str
        }:{
            message: GetMessage(2001),
            valid,
            newText: str
        }
    }
    static multiPhoneNumber (str,label,type) {
        let array_number = str.split(",")
        var errors = []
        array_number.forEach(value=>{
            //
            let lengthResult=this.lengthWithHyphenRemove(value,label,type)
            if ( !lengthResult["valid"] ) {
                errors.push( {...lengthResult,newText:str} )
            }
            let numberResult = this.numberOnly(value,label,type)
            if ( !numberResult["valid"] ) {
                errors.push( {...numberResult,newText:str} )
            }
        })
        return (errors.length > 0)? errors[0]: {message:"",valid: true,newText: str}
    }

    static lengthWithalphanumeric(str,label,type){
        const lengthData = valid_Length[type];
        const min = parseInt(lengthData[0]);
        const max = parseInt(lengthData[1]);
        const rx = new RegExp("^([0-9a-zA-Z])+$");
        const valid = rx.test(str)
        const message = str.length == 0? GetMessage(2024) : lengthData[2]

        return (str.length >= min && str.length <= max && valid)?
        {
            message:"",
            valid: true,
            newText: str
        }:{
            message: message,
            valid : false,
            newText: str
        }        
    }

    static withoutDoubleQuote(str,label,type){
        return (!str.includes('"'))?
        {
            message:"",
            valid: true,
            newText: str
        }:{
            message: GetMessage(2605),
            valid: false,
            newText: str
        }

    }

    static mobileWithalphanumeric (str,label,type) {
        let array_number = str.split(",")
        var errors = []
        array_number.forEach(value=>{
            //
            let lengthResult=this.lengthWithHyphenRemove(value,label,type)
            if ( !lengthResult["valid"] ) {
                errors.push( {...lengthResult,newText:str} )
            }
            let numberResult = this.numberOnly(value,label,type)
            if ( !numberResult["valid"] ) {
                errors.push( {...numberResult,newText:str} )
            }
            var mobileResut  = this.mobileCheck(str)
            if (!mobileResut["valid"]){
                errors.push( {...mobileResut,newText:str} )
            }
        })
        return (errors.length > 0)? errors[0]: {message:"",valid: true,newText: str}
    }

}

const valid_MinMax = {		
    // capacity_qty_1:["0","100","数値 整数以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：100   [VaridationID：capacity_qty_1]"],	
    time_1:["0","1000",GetMessage(2006)],	
    distance_1:["0","5000",GetMessage(2007)],	
    percent_1:["0","99",GetMessage(2025)],	
    // months_1:["0","100","数値 整数以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：100   [VaridationID：months_1]"],	
    amt_1:["0","100000000",GetMessage(2008)],	
    amt_2:["-100000000","100000000",GetMessage(2027)],	
    amt_3:["-100000000","0", GetMessage(2009)],
    // flag_1:["0","9","数値 整数以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：9   [VaridationID：flag_1]"],	
    num_1:["0","100",GetMessage(2010)],
    month_1:["0","100",GetMessage(2010)],
    capacity_qty_1:["0","1000",GetMessage(2011)],
    dueday_1:["1","30",GetMessage(2028)],
}

const valid_Date = {
    date_1:["7948800000","157766400000",GetMessage(2012)],
    date_2:["現在日時","157766400000",GetMessage(2013)]
};

const valid_Length = {	
    // url_1:["0","200","英数字 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：200文字"],
    // alphanumeric_1:["0","255","英数字 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：255文字"],
    id_1:["0","255",GetMessage(2014)],
    id_2:["6","8",GetMessage(2031)],
    zip_1:["8","8",GetMessage(2015)],
    mail_1:["0","2048",GetMessage(2004)],
    tel_fax_1:["10","11",GetMessage(2003)],
    tel_fax_2:["11","11",GetMessage(2026)],
    tel_fax_3:["10","11",GetMessage(2003)],
    tel_fax_4:["10","10",GetMessage(2038)],
    text_long_1:["0","1000",GetMessage(2018)],
    text_long_2:["0","20000",GetMessage(2030)],
    text_long_3:["0","4096",GetMessage(2034)],
    text_long_4:["0","1024",GetMessage(2039)],
    text_80:["0","80",GetMessage(2040)],    
    text_ja_255:["0","255",GetMessage(2019)],
    text_ja_245:["0","245",GetMessage(2029)],
    text_ja_20000:["0","20000",GetMessage(2030)],
    text_ja_2:["0","255",GetMessage(2020)],
    text_ja_3:["0","255",GetMessage(2021)],
    bank_no_1:["7","7",GetMessage(2022)],
    text_ja_60:["0","60",GetMessage(2032)],
    natural_id:["18","18",GetMessage(2033)],
    text_long_without_doublequote:["0","1000",GetMessage(2018)],
    dandori_work_place_code:["0","45",GetMessage(2608)],
    dandori_work_access_token:["32","32",GetMessage(2609)],
};	

const valid_File = {	
	file_1:["","",GetMessage(2023)]
};

const required_message = GetMessage(2024)

